import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class InvFifoCostsService {

  // endpoints
  invCostsEp: string = `${this._apiSvc.endpoints.inventory}/api/InventoryQuantity/Cost`;

  constructor(
    private _apiSvc: ApiService
  ) { }

  /**
   * Get fifo costs by product model id
   * @param pmid 
   */
  get(pmid: number): Observable<any> {
    return this._apiSvc.get(`${this.invCostsEp}/${pmid}`)
  }

}
